import React, { useEffect, useState } from "react";
import keys from "../config/keys";
import { Avatar, Box, Grid, Stack, Typography } from "@mui/material";
import productPay from "../assets/icons/productPay.svg";
import { useNavigate } from "react-router-dom";

interface HomePageProps {
  openPayPage: boolean;
  setOpenPayPage: React.Dispatch<React.SetStateAction<boolean>>;
}

function HomePage(props: HomePageProps) {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${keys}/product-template/getAllTemplatesWithProduct`)
      .then((response) => response.json())
      .then(({ data }) => setProducts(data));
  }, []);

  useEffect(() => {
    props.setOpenPayPage(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack pt={2}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignSelf: "center",
          justifyContent: "center",
          gap: 3,
          "& > :not(style)": {
            m: 1,
            width: 296,
            height: 294,
            borderRadius: 4,
          },
        }}
      >
        {products?.map((item: any, index) => (
          <Grid
            key={index}
            container
            spacing={2}
            direction="column"
            alignItems="center"
            justifyContent="center"
            boxShadow="0px 45px 65px rgba(51, 51, 51, 0.15) "
            sx={{ cursor: "pointer" }}
            onClick={() => navigate(`/product/${item?.productId}`)}
          >
            <Grid item>
              <Avatar
                src={productPay}
                alt="Remy Sharp"
                sx={{
                  height: 68,
                  width: 68,
                }}
              />
            </Grid>
            <Grid item>
              <Typography
                align="center"
                sx={{
                  fontFamily: "FbCoherentiSans",
                  fontSize: 26,
                  pb: 2,
                }}
              >
                {item["product.name"]}
              </Typography>
              <Typography
                align="center"
                sx={{ fontFamily: "FbCoherentiSans-light", opacity: 0.45 }}
                variant="body2"
              >
                {item["product.description"]}
              </Typography>{" "}
            </Grid>
          </Grid>
        ))}
      </Box>
    </Stack>
  );
}

export default HomePage;
